<template>
  <div class="sku-container">
    <div v-if="!disabled" class="sku-check">
      <div v-if="theme == 1" class="theme-1">
        <el-card v-for="(item, index) in myAttribute" :key="index" class="item" shadow="never">
          <div slot="header">{{ item.name }}</div>
          <el-checkbox v-for="(item2, index2) in item.item" :key="index2" v-model="item2.checked" :label="item2.name" size="small" />
          <el-input
            v-if="item.canAddAttribute"
            v-model="item.addAttribute"
            size="small"
            placeholder="新增一个规格"
            class="add-attr"
            @keyup.enter.native="onAddAttribute(index)"
          >
            <el-button slot="append" size="small" icon="el-icon-plus" @click="onAddAttribute(index)">添加</el-button>
          </el-input>
        </el-card>
      </div>
      <el-table v-else :data="myAttribute" :show-header="false" class="theme-2">
        <el-table-column prop="name" width="120" :resizable="false" />
        <el-table-column>
          <template slot-scope="scope">
            <el-checkbox v-for="(item2, index2) in scope.row.item" :key="index2" v-model="item2.checked" :label="item2.name" size="small" />
          </template>
        </el-table-column>
        <el-table-column width="250">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.addAttribute"
              size="small"
              placeholder="新增一个规格"
              class="add-attr"
              @keyup.enter.native="onAddAttribute(scope.$index)"
            >
              <el-button slot="append" size="small" icon="el-icon-plus" @click="onAddAttribute(scope.$index)">添加</el-button>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="sku-list">
      <el-form ref="form" :model="form" status-icon inline-message>
        <el-table :data="form.skuData" stripe border highlight-current-row ref="table1" :row-key="getRowKey" :expand-row-keys="expandRowKeys" @expand-change="handleExpandChange">
          <!-- BMS编码展开行 -->
          <el-table-column v-if="showBmsCode && emitAttribute.length > 0" type="expand" width="50">
            <template slot-scope="scope">
              <div class="bms-expand-content">
                <div class="bms-header">
                  <span class="bms-title">BMS编码列表</span>
                  <el-button type="primary" size="mini" @click="openBmsDialog(scope.$index)">+ 添加BMS编码</el-button>
                </div>
                <el-table v-if="scope.row.bms_codes && scope.row.bms_codes.length > 0" :data="scope.row.bms_codes" border size="mini" class="bms-inner-table">
                  <el-table-column prop="iprod" label="编码" width="180" />
                  <el-table-column prop="idesc" label="名称" min-width="250" />
                  <el-table-column prop="idsce" label="规格" width="320" />
                  <el-table-column prop="number" label="数量" width="100" />
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="bmsScope">
                      <el-button type="text" size="mini" @click="removeBmsCode(scope.$index, bmsScope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-else class="bms-empty">暂无BMS编码，请点击上方按钮添加</div>
              </div>
            </template>
          </el-table-column>
          <!-- 考虑到异步加载的情况，如果 attribute 数据先加载完成，则表头会立马展示，效果不理想，故使用emitAttribute 数据，该数据为计算属性，通过 myAttribute 生成，结构与 attribute 一致 -->
          <el-table-column v-if="emitAttribute.length > 0" type="index" width="50" align="center" :resizable="false" />
          <el-table-column
            v-for="(attr, index) in emitAttribute"
            :key="`attribute-${index}`"
            :label="attr.name"
            :prop="attr.name"
            width="200"
            align="center"
            :resizable="false"
            sortable
          />
          <el-table-column
            v-if="attribute.length > 0 && item.label != 'uuid'"
            v-for="(item, index) in structure"
            :key="`structure-${index}`"
            :label="item.label"
            :prop="item.name"
            align="center"
            :resizable="false"
            min-width="200px"
          >
            <!-- 自定义表头 -->
            <template slot="header">
              <span :class="{ required_title: item.required }">
                {{ item.label }}
              </span>
              <el-tooltip v-if="item.tip" effect="dark" :content="item.tip" placement="top">
                <i class="el-icon-info" />
              </el-tooltip>
            </template>
            <!-- 自定义表格内部展示 -->
            <template slot-scope="scope">
              <!-- 增加是 key 是为了保证异步验证不会出现 skuData 数据变化后无法验证的 bug -->
              <el-form-item
                v-if="item.type == 'input' && item.label != 'uuid'"
                :key="`structure-input-${index}-${scope.row.sku}`"
                :prop="'skuData.' + scope.$index + '.' + item.name"
                :rules="rules[item.name]"
              >
                <el-input v-model="scope.row[item.name]" :placeholder="`请输入${item.label}`" size="small" />
              </el-form-item>
              <el-form-item
                v-else-if="item.type == 'slot'"
                :key="`structure-input-${index + 1}-${scope.row.sku}`"
                :prop="'skuData.' + scope.$index + '.' + item.name"
                :rules="rules[item.name]"
              >
                <slot :name="item.name" :$index="scope.$index" :row="scope.row" :column="scope.column" />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 批量设置，当 sku 数超过 2 个时出现 -->
          <template v-if="isBatch && form.skuData.length > 2" slot="append">
            <el-table :data="[{}]" :show-header="false" ref="table2">
              <el-table-column :width="attribute.length * 200 + 50" align="center" :resizable="false">批量设置</el-table-column>
              <el-table-column
                v-for="(item, index) in structure"
                :key="`batch-structure-${index}`"
                align="center"
                :resizable="false"
                min-width="200px"
              >
                <el-input
                  v-if="item.type == 'input' && item.batch != false"
                  v-model="batch[item.name]"
                  :placeholder="`填写一个${item.label}`"
                  size="small"
                  @keyup.enter.native="onBatchSet(item.name)"
                />
              </el-table-column>
            </el-table>
          </template>
        </el-table>
      </el-form>
    </div>
    <!-- BMS编码选择对话框 -->
    <el-dialog title="选择BMS编码" :visible.sync="bmsDialogVisible" center width="65%" append-to-body @closed="closeBmsDialog">
      <el-table
        ref="bmsTableRef"
        :data="bmsTableData"
        border
        max-height="500"
        @selection-change="handleBmsSelectionChange"
        v-loading="bmsLoading"
        element-loading-text="正在加载数据..."
        :header-cell-style="{ padding: '2px 0' }"
        :cell-style="{ padding: '2px 0' }"
        row-key="iprod"
      >
        <el-table-column type="selection" width="50" align="center" :reserve-selection="true" />
        <el-table-column prop="iprod" label="编码" width="140" />
        <el-table-column prop="idesc" label="名称" />
        <el-table-column prop="idsce" label="规格" />
        <el-table-column prop="number" label="数量" width="190">
          <template slot-scope="scope">
            <el-input-number :min="0" style="width: 160px" v-model="scope.row.number" placeholder="请输入数量" size="small" />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBmsDialog">取 消</el-button>
        <el-button type="primary" :disabled="!bmsSelectedRows.length" @click="confirmBmsSelect">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "SkuForm",
    props: {
      isEdit: {
        type: Boolean,
        default: false,
      },
      /**
       * 原始规格数据
       * sourceAttribute: [
       *   { name: '颜色', item: ['黑', '金', '白'] },
       *   { name: '内存', item: ['16G', '32G'] },
       *   { name: '运营商', item: ['电信', '移动', '联通'] }
       * ]
       */
      sourceAttribute: {
        type: Array,
        default: () => [],
      },
      /**
       * 已使用的规格数据，用于复原数据，支持.sync修饰符
       * attribute: [
       *   { name: '颜色', item: ['黑'] },
       *   { name: '运营商', item: ['电信', '移动', '联通'] }
       * ]
       */
      attribute: {
        type: Array,
        default: () => [],
      },
      /**
       * 用于复原sku数据，支持.sync修饰符
       * sku: [
       *   { sku: '黑;电信', price: 1, stock: 1 },
       *   { sku: '黑;移动', price: 2, stock: 2 },
       *   { sku: '黑;联通', price: 3, stock: 3 }
       * ]
       */
      sku: {
        type: Array,
        default: () => [],
      },
      /**
       * 表格结构，注意name字段，用于输出sku数据
       */
      structure: {
        type: Array,
        default: () => [
          { name: "price", type: "input", label: "价格" },
          { name: "stock", type: "input", label: "库存" },
        ],
      },
      // sku 字段分隔符
      separator: {
        type: String,
        default: ";",
      },
      // 无规格的 sku
      emptySku: {
        type: String,
        default: "",
      },
      // 是否显示 sku 选择栏
      disabled: {
        type: Boolean,
        default: false,
      },
      // 主题风格
      theme: {
        type: Number,
        default: 1,
      },
      // 是否开启异步加载
      async: {
        type: Boolean,
        default: false,
      },
      // 是否显示BMS编码功能
      showBmsCode: {
        type: Boolean,
        default: false,
      },
      // 自动结构化行规格
      isStructure: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isInit: false,
        myAttribute: [],
        form: {
          skuData: [],
        },
        times: 1,
        batch: {},
        oldData: [],
        opts: {},
        // BMS编码相关
        expandRowKeys: [],
        bmsDialogVisible: false,
        bmsLoading: false,
        bmsTableData: [],
        bmsSelectedRows: [],
        currentBmsIndex: -1,
        bmsCodeOpts: {},
      };
    },
    mounted() {},
    computed: {
      rules() {
        // 重新生成验证规则
        let rules = {};
        this.structure.forEach((v) => {
          if (v.type == "input") {
            rules[v.name] = [];
            if (v.required) {
              rules[v.name].push({ required: true, message: `${v.label}不能为空`, trigger: "blur" });
            }
            if (v.validate) {
              rules[v.name].push({ validator: this.customizeValidate, trigger: "blur" });
            }
          } else if (v.type == "slot") {
            rules[v.name] = [];
            if (v.required) {
              rules[v.name].push({ required: true, message: `${v.label}不能为空`, trigger: ["change", "blur"] });
            }
            if (v.validate) {
              rules[v.name].push({ validator: this.customizeValidate, trigger: ["change", "blur"] });
            }
          }
        });
        return rules;
      },
      isBatch() {
        return this.structure.some((item) => {
          return item.type == "input" && item.batch != false;
        });
      },
      // 将 myAttribute 数据还原会 attribute 数据的结构，用于更新 attribute
      emitAttribute() {
        let attribute = [];
        this.myAttribute.forEach((v1) => {
          const obj = {
            name: v1.name,
            item: [],
          };
          v1.item.forEach((v2) => {
            if (v2.checked) {
              obj.item.push(v2.name);
            }
          });
          if (obj.item.length !== 0) {
            attribute.push(obj);
          }
        });
        return attribute;
      },
    },
    watch: {
      sku(n) {
        this.oldData = { ...n };
      },
      myAttribute: {
        handler() {
          if (!this.isInit) {
            // 更新父组件
            this.$emit("update:attribute", this.emitAttribute);
          }
          this.setSkuOpts();
          // 解决通过 $emit 更新后无法拿到 attribute 最新数据的问题
          this.$nextTick(() => {
            if (this.attribute.length !== 0) {
              this.combinationAttribute();
            } else {
              this.form.skuData = [];
              const obj = {
                sku: this.emptySku,
              };
              this.structure.forEach((v) => {
                if (!(v.type == "slot" && v.skuProperty == false)) {
                  obj[v.name] = typeof v.defaultValue != "undefined" ? v.defaultValue : "";
                }
              });
              this.form.skuData.push(obj);
            }
            this.clearValidate();
          });
        },
        deep: true,
      },
      "form.skuData": {
        handler(newValue) {
          if (this.isInit) {
            return;
          }
          let data = [];
          if (newValue && newValue.length > 0) {
            if (newValue.length == 1 && newValue[0].sku == this.emptySku) {
              data = [];
            } else {
              const arr = [];
              newValue.forEach((v1) => {
                const obj = {
                  ...v1,
                  sku: v1.sku,
                };
                this.structure.forEach((v2) => {
                  if (!(v2.type == "slot" && v2.skuProperty == false)) {
                    obj[v2.name] = v1[v2.name] || (typeof v2.defaultValue != "undefined" ? v2.defaultValue : "");
                  }
                });
                arr.push(obj);
              });
              data = arr;
            }
          }
          this.$emit("update:sku", data);
        },
        deep: true,
      },
    },
    created() {},
    mounted() {
      !this.async && this.init();
    },
    methods: {
      init() {
        this.$nextTick(() => {
          this.isInit = true;
          // 初始化 myAttribute
          let myAttribute = [];
          // 根据 sourceAttribute 复原 myAttribute 的结构
          this.sourceAttribute.forEach((v) => {
            const temp = {
              name: v.name,
              canAddAttribute: typeof v.canAddAttribute != "undefined" ? v.canAddAttribute : true,
              addAttribute: "",
              item: [],
            };
            v.item.forEach((itemName) => {
              temp.item.push({
                name: itemName,
                checked: false,
              });
            });
            myAttribute.push(temp);
          });
          // 根据 attribute 更新 myAttribute
          this.attribute.forEach((attrVal) => {
            myAttribute.forEach((myAttrVal) => {
              if (attrVal.name === myAttrVal.name) {
                attrVal.item.forEach((attrName) => {
                  if (
                    !myAttrVal.item.some((myAttrItem) => {
                      if (attrName === myAttrItem.name) {
                        myAttrItem.checked = true;
                      }
                      return attrName === myAttrItem.name;
                    })
                  ) {
                    myAttrVal.item.push({
                      name: attrName,
                      checked: true,
                    });
                  }
                });
              }
            });
          });
          this.myAttribute = myAttribute;

          // 通过 sku 更新 skuData，但因为 skuData 是实时监听 myAttribute 变化并自动生成，而 watch 是在 methods 后执行，所以增加 setTimeout 方法，确保 skuData 生成后在执行下面的代码
          setTimeout(() => {
            this.sku.forEach((skuItem, index) => {
              if (this.isEdit) {
                for (let i in skuItem) {
                  this.form.skuData[index][i] = skuItem[i];
                }
              }
              if (this.isStructure) {
                this.form.skuData.forEach((skuDataItem) => {
                  if (skuItem.sku === skuDataItem.sku) {
                    this.structure.forEach((structureItem) => {
                      skuDataItem[structureItem.name] = skuItem[structureItem.name];
                    });
                  }
                });
              }
            });

            this.isInit = false;
          }, 100);
        });
      },
      // 根据 attribute 进行排列组合，生成 skuData 数据
      combinationAttribute(index = 0, dataTemp = []) {
        if (index === 0) {
          for (let i = 0; i < this.attribute[0].item.length; i++) {
            const obj = {
              sku: this.attribute[0].item[i],
              [this.attribute[0].name]: this.attribute[0].item[i],
            };
            this.structure.forEach((v) => {
              if (!(v.type == "slot" && v.skuProperty == false)) {
                obj[v.name] = typeof v.defaultValue != "undefined" ? v.defaultValue : "";
              }
            });
            dataTemp.push(obj);
          }
        } else {
          const temp = [];
          for (let i = 0; i < dataTemp.length; i++) {
            for (let j = 0; j < this.attribute[index].item.length; j++) {
              temp.push(JSON.parse(JSON.stringify(dataTemp[i])));
              temp[temp.length - 1][this.attribute[index].name] = this.attribute[index].item[j];
              temp[temp.length - 1]["sku"] = [temp[temp.length - 1]["sku"], this.attribute[index].item[j]].join(this.separator);
            }
          }
          dataTemp = temp;
        }
        if (index !== this.attribute.length - 1) {
          this.combinationAttribute(index + 1, dataTemp);
        } else {
          dataTemp = dataTemp.map((item) => {
            const key = this.attribute.map(({ name }) => item[name]).join("_");
            const row = this.opts[key] || { ...item };
            //
            return { ...row };
          });
          this.form.skuData = dataTemp;
        }
      },
      // 新增一个规格
      onAddAttribute(index) {
        this.myAttribute[index].addAttribute = this.myAttribute[index].addAttribute.trim();
        if (this.myAttribute[index].addAttribute !== "") {
          if (!this.myAttribute[index].addAttribute.includes(this.separator)) {
            const flag = this.myAttribute[index].item.some((item) => {
              return item.name === this.myAttribute[index].addAttribute;
            });
            if (!flag) {
              this.myAttribute[index].item.push({
                name: this.myAttribute[index].addAttribute,
                checked: true,
              });
              this.myAttribute[index].addAttribute = "";
            } else {
              this.$message({
                type: "warning",
                message: "请勿添加相同规格",
              });
            }
          } else {
            this.$message({
              type: "warning",
              message: `规格里不允许出现「 ${this.separator} 」字符，请检查后重新添加`,
            });
          }
        }
      },
      onBatchSet(type) {
        if (this.batch[type] != "") {
          this.form.skuData.forEach((v) => {
            v[type] = this.batch[type];
          });
          this.batch[type] = "";
          // 批量设置完成后，触发一次当前列的验证
          this.validateFieldByColumns([type], () => {});
        }
      },
      // 自定义输入框验证，通过调用 structure 里的 validate 方法实现，重点是 callback 要带过去
      customizeValidate(rule, value, callback) {
        let [model, index, name] = rule.field.split(".");
        this.structure.forEach((v) => {
          if (v.name == name) {
            v.validate(this.form[model], index, callback);
          }
        });
      },
      // sku 表单验证
      validate(callback) {
        this.$refs["form"].validate((valid) => {
          callback(valid);
        });
      },
      validateFieldByColumns(colums, callback) {
        let props = [];
        this.form.skuData.forEach((v, i) => {
          colums.forEach((v) => {
            props.push(`skuData.${i}.${v}`);
          });
        });
        this.$refs["form"].validateField(props, (valid) => {
          callback(valid);
        });
      },
      validateFieldByRows(index, prop, callback) {
        this.$refs["form"].validateField([`skuData.${index}.${prop}`], (valid) => {
          callback(valid);
        });
      },
      clearValidate() {
        this.$refs["form"].clearValidate();
      },
      setSkuOpts() {
        if (this.attribute.length > 0) {
          const skuData = [...this.form.skuData];
          skuData.forEach((item) => {
            const key = this.attribute.map(({ name }) => item[name]).join("_");
            this.opts[key] = { ...item };
          });
        }
      },
      // BMS编码相关方法
      getRowKey(row) {
        return row.sku || row.uuid || Math.random().toString(36).substr(2, 9);
      },
      handleExpandChange(row, expandedRows) {
        this.expandRowKeys = expandedRows.map((r) => this.getRowKey(r));
      },
      queryBmsCodes() {
        if (this.bmsTableData.length > 0) return Promise.resolve();
        this.bmsLoading = true;
        return this.axios({
          method: "get",
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: "https://time.api.boyalife.cn/v1/cms/Goods/bms_codes",
        })
          .then((res) => {
            const codeOpts = {};
            this.bmsTableData = (res.data.result || []).map(({ IPROD, IDESC, IDSCE }) => {
              codeOpts[IPROD] = { idesc: IDESC, idsce: IDSCE };
              return {
                iprod: IPROD,
                idesc: IDESC,
                idsce: IDSCE,
                number: 0,
              };
            });
            this.bmsCodeOpts = codeOpts;
          })
          .catch((err) => {
            const msg = err.response && err.response.data && err.response.data.error && err.response.data.error.message;
            this.$message.error(msg || "获取BMS编码失败");
          })
          .finally(() => {
            this.bmsLoading = false;
          });
      },
      openBmsDialog(index) {
        this.currentBmsIndex = index;
        this.bmsDialogVisible = true;
        this.queryBmsCodes().then(() => {
          // 恢复当前规格已选择的BMS编码
          const currentRow = this.form.skuData[index];
          const currentBmsCodes = currentRow.bms_codes || [];
          // 合并已有数据到表格
          const opts = {};
          currentBmsCodes.forEach((item) => {
            opts[item.iprod] = { ...item };
          });
          this.bmsTableData = this.bmsTableData.map((item) => {
            const existing = opts[item.iprod];
            return existing ? { ...item, ...existing } : { ...item, number: 0 };
          });
          // 选中已有的行
          this.$nextTick(() => {
            if (this.$refs.bmsTableRef) {
              this.$refs.bmsTableRef.clearSelection();
              currentBmsCodes.forEach((code) => {
                const row = this.bmsTableData.find((item) => item.iprod === code.iprod);
                if (row) {
                  this.$refs.bmsTableRef.toggleRowSelection(row, true);
                }
              });
            }
          });
        });
      },
      closeBmsDialog() {
        this.bmsDialogVisible = false;
        this.bmsSelectedRows = [];
        this.currentBmsIndex = -1;
      },
      handleBmsSelectionChange(rows) {
        this.bmsSelectedRows = rows;
      },
      confirmBmsSelect() {
        if (!this.bmsSelectedRows.length) {
          this.$message.warning("请先选择BMS编码");
          return;
        }
        const rows = this.bmsSelectedRows.map((item) => {
          const { uuid, iprod, number, idesc, idsce } = item;
          return { uuid, iprod, number: number || 0, idesc, idsce };
        });
        if (rows.find((item) => Number(item.number || 0) <= 0)) {
          this.$message.warning("请输入数量");
          return;
        }
        // 更新对应规格的bms_codes
        if (this.currentBmsIndex >= 0 && this.form.skuData[this.currentBmsIndex]) {
          this.$set(this.form.skuData[this.currentBmsIndex], "bms_codes", rows);
        }
        this.closeBmsDialog();
      },
      removeBmsCode(skuIndex, bmsIndex) {
        if (this.form.skuData[skuIndex] && this.form.skuData[skuIndex].bms_codes) {
          this.form.skuData[skuIndex].bms_codes.splice(bmsIndex, 1);
        }
      },
    },
  };
</script>

<style scoped>
  .sku-container::v-deep .el-card {
    margin: 10px 0;
  }
  .sku-container::v-deep .el-card .el-card__header {
    line-height: initial;
    padding: 10px 20px;
  }
  .sku-container::v-deep .el-card .el-card__body {
    padding: 10px 20px 20px;
  }
  .sku-container .sku-check .theme-1 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .sku-container .sku-check .item {
    width: 32%;
  }
  .sku-container .sku-check .item:last-child:nth-child(3n - 1) {
    margin-right: calc(100% - 32% * 2 - 4% / 2) !important;
  }
  .sku-container .sku-check .item.add-attr {
    width: 100%;
    margin-top: 10px;
  }

  .sku-container .sku-check .theme-2 {
    border: 1px solid #ebeef5;
    border-bottom: 0;
    margin-bottom: 20px;
  }
  .sku-container .sku-check .sku-name {
    text-align: right;
  }
  .sku-container .sku-check .batch-set {
    width: 100%;
    margin-top: 5px;
  }
  .sku-container .sku-check .sku-list {
    line-height: initial;
  }
  .sku-container .sku-check .sku-list::v-deep .el-table__append-wrapper {
    overflow: initial;
  }
  .sku-container .sku-check .sku-list:v-deep .el-input__inner {
    text-align: center;
  }
  .sku-container .sku-check .sku-list::v-deep .el-table__append-wrapper {
    overflow: initial;
  }
  .sku-container .sku-check .sku-list .el-table {
    overflow: initial;
  }
  .sku-container .sku-check .sku-list .el-table .el-table__body-wrapper {
    overflow: initial;
  }
  .sku-container .sku-list::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .sku-container .sku-list .el-form-item__content {
    line-height: initial;
  }
  .sku-container .sku-list .el-form-item__error {
    margin-left: 0;
  }
  .sku-container .sku-list .required_title::before {
    content: "*";
    color: #f56c6c;
  }
  /* BMS编码展开行样式 */
  .bms-expand-content {
    padding: 10px 15px;
    background: #fafafa;
    display: inline-block;
    min-width: 1000px;
  }
  .bms-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .bms-title {
    font-weight: bold;
    font-size: 13px;
    color: #333;
  }
  .bms-inner-table {
    width: 970px !important;
  }
  .bms-empty {
    color: #999;
    text-align: center;
    padding: 15px 0;
    font-size: 12px;
  }
  .dialog-footer {
    text-align: center;
  }
</style>
